import Tile from '~/components/audiences/Tile';
import Layout from '~/components/Layout';
import TimeAgo from '~/components/TimeAgo';
import { readableAudienceSubtype } from '~/lib/audiences';
import paths from '~/lib/paths';

import ActionsMenu from './ActionsMenu';
import styles from './styles';

function AudiencesLayout({
  audience,
  background,
  breadcrumb = [],
  children,
  classes,
  viewer,
  ...props
}) {
  return (
    <Layout
      actions={<ActionsMenu audience={audience} viewer={viewer} />}
      breadcrumb={[
        {
          title: 'Audiences',
          path: paths.audiences(),
        },
        ...breadcrumb,
      ]}
      className={classes[background]}
      tile={<Tile audience={audience} size={50} />}
      shadow
      subtitle={<Subtitle audience={audience} />}
      {...props}>
      {children}
    </Layout>
  );
}

AudiencesLayout.propTypes = {
  audience: PropTypes.object,
  background: PropTypes.oneOf(['grey', 'white']),
  breadcrumb: PropTypes.array,
  children: PropTypes.node,
  classes: PropTypes.object.isRequired,
  viewer: PropTypes.object,
};

AudiencesLayout.defaultProps = {
  background: 'white',
};

AudiencesLayout.ContentSection = Layout.ContentSection;

function Subtitle({ audience }) {
  if (!audience || !audience.subtype) {
    return 'Loading...';
  }

  return (
    <>
      A <strong>{readableAudienceSubtype(audience.subtype)} audience</strong>{' '}
      created
      {audience.user && (
        <>
          {' '}
          by <strong>{audience.user.name}</strong>{' '}
        </>
      )}
      {audience.createdAt && (
        <>
          {' '}
          <TimeAgo time={audience.createdAt} />
        </>
      )}
    </>
  );
}

Subtitle.propTypes = {
  audience: PropTypes.object,
};

export default withStyles(styles)(AudiencesLayout);
